/// <reference types="vite/client" />

declare global {
  interface Window {
    __RUNTIME_ENV__?: Record<string, string | undefined>;
  }
}

const runtimeEnv = typeof window !== 'undefined' ? window.__RUNTIME_ENV__ : undefined;

export function getEnv(key: string): string | undefined {
  return runtimeEnv?.[key] ?? import.meta.env[key];
}

export { runtimeEnv };
